import { EntityTable } from '@/features/admin/EntityTable';
import { Badge } from '@/components/ui/Badge';

export function EmbalagensPage() {
  return (
    <EntityTable
      title="Embalagens"
      subtitle="SMS, Tyvek, container etc. — define validade base e compatibilidade térmica"
      endpoint="/v1/packaging"
      queryKey="packaging"
      columns={[
        { key: 'name', label: 'Nome' },
        { key: 'base_validity_days', label: 'Validade (dias)', className: 'text-right tabular-nums' },
        {
          key: 'compat', label: 'Compatibilidade',
          render: (r: any) => (
            <div className="flex flex-wrap gap-1">
              {r.steam_compatible ? <Badge tone="info">Vapor</Badge> : null}
              {r.plasma_compatible ? <Badge tone="brand">Plasma</Badge> : null}
            </div>
          ),
        },
      ]}
      fields={[
        { name: 'name', label: 'Nome', type: 'text', required: true },
        { name: 'base_validity_days', label: 'Validade base (dias)', type: 'number', required: true, min: 1, max: 3650, defaultValue: 180 },
        { name: 'supplier_id', label: 'Fornecedor', type: 'entity', endpoint: '/v1/suppliers', displayField: 'name', secondaryField: 'cnpj' },
        { name: 'steam_compatible', label: 'Compatível com vapor', type: 'checkbox', defaultValue: true },
        { name: 'plasma_compatible', label: 'Compatível com plasma (H2O2)', type: 'checkbox', defaultValue: false },
      ]}
    />
  );
}
